"use client";

import cn from "classnames";

import type { Article } from "../../../../../types/content";

import styles from "./SalesPosterButtons.module.scss";
import { usePulse } from "../../../../../pulse/usePulse";
import { login } from "../../../../../utils/auth/login";
import { Button } from "../../../../Button/Button";
import { getHref } from "../helper";

const SalesPosterButtons = ({
  article,
  isOmniEconomy,
}: {
  article?: Article;
  isOmniEconomy: boolean;
}) => {
  const { trackSubscriptionClick } = usePulse();
  const href = getHref(isOmniEconomy, article);

  return (
    <div className={styles.cta}>
      <Button
        size="large"
        variant="secondary"
        text={"Logga in"}
        isPremium={true}
        className={cn(isOmniEconomy && styles.economySecondaryButton)}
        onClick={login}
      />
      <Button
        size="large"
        variant="primary"
        text={"Bli medlem"}
        isPremium={true}
        type="link"
        isExternalLink
        className={cn(isOmniEconomy && styles.economyPrimaryButton)}
        href={href}
        onClick={() => trackSubscriptionClick(href, article)}
      />
    </div>
  );
};

export { SalesPosterButtons };
